/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Stránka bez názvu',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': 'Vytvořit novou stránku a vložte ji jako odkaz',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Vytvořit stránku Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Otevřít v Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Vaše stránka byla vytvořena.',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Stránka byla vytvořena',
  'editorExtensionLinkCreate.confluencePage.title': 'Vytvořit novou stránku',
  'editorExtensionLinkCreate.genericError.description': 'Obnovte stránku a zkuste to znovu.',
  'editorExtensionLinkCreate.genericError.title': 'Něco se pokazilo',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description': 'Vytvořit vložený požadavek a vložit jej jako odkaz',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description-issue-terminology-refresh-m4':
    'Vytvořit vložený požadavek a vložit jej jako odkaz',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Vytvořit požadavek Jira',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title-issue-terminology-refresh-m4': 'Vytvořit požadavek Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Otevřít v Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Váš požadavek byl vytvořen.',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description-issue-terminology-refresh-m4':
    'Váš požadavek byl vytvořen.',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Požadavek byl vytvořen',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title-issue-terminology-refresh-m4': 'Požadavek byl vytvořen',
  'editorExtensionLinkCreate.jiraIssue.title': 'Vytvořit nový požadavek',
  'editorExtensionLinkCreate.jiraIssue.title-issue-terminology-refresh-m4': 'Vytvořit nový požadavek',
  'editorExtensionLinkCreate.keyword.create': 'vytvořit',
  'editorExtensionLinkCreate.keyword.issue': 'požadavek',
  'editorExtensionLinkCreate.keyword.new': 'nové',
  'editorExtensionLinkCreate.keyword.page': 'stránka',
  'editorExtensionLinkCreate.keyword.publish': 'publikovat',
  'editorExtensionLinkCreate.keyword.raise': 'zadat',
  'editorExtensionLinkCreate.keyword.space': 'prostor',
  'editorExtensionLinkCreate.keyword.ticket': 'ticket',
};
